/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './medication-schedule-details.reducer';

export const MedicationScheduleDetailsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const medicationScheduleDetailsEntity = useAppSelector(state => state.medicationScheduleDetails.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="medicationScheduleDetailsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.detail.title">MedicationScheduleDetails</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.id">Id</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.id}</dd>
          <dt>
            <span id="dose">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.dose">Dose</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.dose}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.active">Active</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{medicationScheduleDetailsEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{medicationScheduleDetailsEntity.glucoUser ? medicationScheduleDetailsEntity.glucoUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.medicine">Medicine</Translate>
          </dt>
          <dd>{medicationScheduleDetailsEntity.medicine ? medicationScheduleDetailsEntity.medicine.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.medication">Medication</Translate>
          </dt>
          <dd>{medicationScheduleDetailsEntity.medication ? medicationScheduleDetailsEntity.medication.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.medicationScheduleDetails.schedule">Schedule</Translate>
          </dt>
          <dd>{medicationScheduleDetailsEntity.schedule ? medicationScheduleDetailsEntity.schedule.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/medication-schedule-details" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/medication-schedule-details/${medicationScheduleDetailsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MedicationScheduleDetailsDetail;
